import React from "react";
import {
  ArrowBackCircle,
  ArrowBackOutline,
  ArrowForwardOutline,
} from "react-ionicons";
import SearchFilterFunction from "../Functions/SearchFilter";
import stylesMed from "../MedRep/stylesMed";
import stylesASAP from "./stylesASAP";
import { set, get } from "idb-keyval";
import { db, getDocs, collection, disableNetwork } from "../firebase";
import { FcHome } from "react-icons/fc"

export default class ProductsASAP extends React.Component {
  constructor() {
    super();
    this.state = {
      products: [],
      productsCopy: [],
      loading: true,
      noData: true,
      token: "",
      authenticate: false,
      alertUndefined: false,
      offset: 0,
      offsetFixed: 0,
      countP: 1,
      catalogs : [],
      settingArray: [],
      random :0
    };
  }

  async componentDidMount() {
    document.body.style.backgroundColor = "#e6e6fa";

    const token = JSON.parse(localStorage.getItem("Token"));
    const catalogId = JSON.parse(localStorage.getItem("CatalogId"));
    const catalogs = JSON.parse(localStorage.getItem("Catalogs"));
    const settingArray = JSON.parse(localStorage.getItem("SettingArray"));
    const random = JSON.parse(localStorage.getItem("random"));
    this.setState({ token: token, catalogId: catalogId , catalogs: catalogs ,  settingArray: settingArray, random : random});
    //    await disableNetwork(db).then(async () => {
    //         this.readData();
    //     })
    await this.readData();
    await this.setCurrentCatalog();
  }

  // readData = async () => {
  //     const querySnapshot = await getDocs(collection(db, "Items"));
  //     const Items = querySnapshot.docs.map((doc) => ({
  //         id: doc.id,
  //         ...doc.data()
  //     }));
  //     this.setState({products: Items, productsCopy: Items, loading: false})
  // }

  readData = async () => {
    try {
      // Use 'get' method from idb-keyval to read data from IndexedDB
      const data = await get("items");
      const withStock = data.filter(
        (item) =>
          item.external_onhand_qty !== "false" &&
          parseFloat(item.external_onhand_qty) > 0,
      );
      const uniqueArray = withStock.filter((obj, index, self) =>
        index === self.findIndex((t) => t.id === obj.id),
      );

      if (data) {
        this.setState({
          products: uniqueArray,
          productsCopy: uniqueArray,
          loading: false,
          ofproducts: Math.round(uniqueArray.length / 8),
        });

        console.log("items from IndexedDB:", uniqueArray);
      } else {
        console.log("items not found in IndexedDB.");
      }
    } catch (error) {
      console.error("Error reading items from IndexedDB:", error);
    }
  };

  onSearch = async (text) => {
    var values = await SearchFilterFunction(
      text,
      this.state.products,
      this.state.productsCopy,
      this.state.noData
    );
    this.setState({
      products: values.items,
      noData: values.noData,
      offset: 0,
      offsetFixed: 0,
      countP: 1,
    });
  };
  onPrevious = async () => {
    await this.setState({
      offset: this.state.offset - 10,
      offsetFixed: this.state.offsetFixed - 1,
      countP: this.state.countP - 1,
    });
    if (this.state.offset < 0) {
      this.setState({ offset: 0, offsetFixed: 0, countP: 1 });
    } else {
      window.scrollTo(0, 0);
    }
  };

  onNext = async () => {
    await this.setState({
      offset: this.state.offset + 10,
      offsetFixed: this.state.offsetFixed + 1,
      countP: this.state.countP + 1,
      imageLoaded: false,
    });
    if (
      this.state.products.slice(this.state.offset, this.state.offset + 10)
        .length === 0
    ) {
      this.setState({
        offset: this.state.offset - 10,
        offsetFixed: this.state.offsetFixed - 1,
        countP: this.state.countP - 1,
      });
    } else {
      window.scrollTo(0, 0);
    }
  };

  setCurrentCatalog = async () => {
    var categItemsOffline = [];
    if (this.state.catalogId === 1) {
      this.setState({
        products: this.state.products,
        productsCopy: this.state.products,
        loading: false,
        ofproducts: Math.round(this.state.productsCopy.length / 10),
      });
      if (this.state.productsCopy.length <= 10) {
        this.setState({ ofproducts: 1 });
      } else {
        this.setState({
          ofproducts: Math.round(this.state.productsCopy.length / 10),
        });
      }
    } else {
      this.state.productsCopy.forEach((item) => {
        if (item.categ_id[0] === this.state.catalogId) {
          categItemsOffline.push(item);
        }
      });
      this.setState({
        products: categItemsOffline,
        productsCopy: categItemsOffline,
        loading: false,
        ofproducts: Math.round(categItemsOffline.length / 10),
      });
      if (categItemsOffline.length === 0) {
        this.setState({ ofproducts: 1 });
      }
    }
  };
  //   onPrevious = async () => {
  //     await this.setState({
  //       offset: this.state.offset - 10,
  //       offsetFixed: this.state.offsetFixed - 1,
  //     });
  //     if (this.state.offset < 0) {
  //       this.setState({ offset: 0, offsetFixed: 0 });
  //     } else {
  //       window.scrollTo(0, 0);
  //     }
  //   };

  //   onNext = async () => {
  //     await this.setState({
  //       offset: this.state.offset + 10,
  //       offsetFixed: this.state.offsetFixed + 1,
  //     });
  //     if (
  //       this.state.products.slice(this.state.offset, this.state.offset + 10)
  //         .length === 0
  //     ) {
  //       this.setState({
  //         offset: this.state.offset - 10,
  //         offsetFixed: this.state.offsetFixed - 1,
  //       });
  //     } else {
  //       window.scrollTo(0, 0);
  //     }
  //   };

  render() {
    if (!this.state.loading) {
      return (
        <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className={this.state.disableSync ? "btn disabled" : "btn"}
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="pt-3">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.goBack()}
              color={"#00bfff"}
              height="50px"
              width="50px"
            />
            <FcHome
              className="btn"
              style={stylesASAP.iconhome}
              onClick={() => this.props.history.push("/LandingPage")}
            />
              <p className="pt-3 text-center h1" style={stylesASAP.itemName}>Item List</p>
          </div>
          <div className="pt-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search Here"
              onInput={(text) => this.onSearch(text)}
            />
          </div>
        
          {this.state.catalogs.map((item, index) => {
                  if (item.id === this.state.catalogId) {
                    return (
                      <p
                        className="little pt-3 text-center h4 mb-3"
                        style={stylesASAP.itemName}
                        key={index}
                      >
                        {item.name} Items
                      </p>
                    );
                  } else return null;
                })}
          <div className="pt-2">
            <div className="row" style={stylesASAP.mainBackgroundColor}>
              {this.state.products
                .slice(this.state.offset, this.state.offset + 10)
                .map((item, index) => {
                  return (
                    <div className="col-sm-6 pt-3" key={index}>
                      <div className="card-body bg-light">
                      {this.state.settingArray.map((url) => {
                            if (url.key === "Product_Images_Base_URL") {
                              return (
                                <div className="col-2 mt-2">
                              
                                    <img
                                      className="image1"
                                      src={
                                        url.value +
                                        item.default_code +
                                        ".png?lastmod="+this.state.random
                                      }
                                      alt="not found"
                                   
                                     
                                    />
                                 
                                </div>
                              );
                            }
                          })}
                        <h3 className="pt-2 text-center">{item.name}</h3>
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
          <div className="row " style={stylesMed.mainBackgroundColor}>
            <div className="col">
              <ArrowBackOutline
                className="btn"
                color={"#00bfff"}
                height="50px"
                width="50px"
                onClick={() => this.onPrevious()}
              />
              <h6>Previous Page</h6>
            </div>
            <div className="col text-center">
              <h6>Page {this.state.countP + " of " + this.state.ofproducts}</h6>
            </div>
            <div className="col" style={stylesMed.rightDirection}>
              <ArrowForwardOutline
                className="btn"
                color={"#00bfff"}
                height="50px"
                width="50px"
                onClick={() => this.onNext()}
              />
              <h6>Next Page</h6>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container-fluid vh-100" style={stylesMed.mainContainer}>
          {!this.state.alertUndefined ? null : (
            <div className="col alert alert-danger">
              <div className="row">
                <h6 className="col-sm-8">There seems to be a problem.</h6>
                <div className="col d-flex flex-row-reverse">
                  <div
                    className={this.state.disableSync ? "btn disabled" : "btn"}
                    style={stylesMed.wideButton}
                    onClick={() => window.location.reload()}
                  >
                    Reload
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className="pt-3">
            <ArrowBackCircle
              className="btn"
              onClick={() => this.props.history.push("./LandingPage")}
              color={"#00bfff"}
              height="50px"
              width="50px"
            />
          </div>
          <div className="pt-3">
            <input
              type="text"
              className="form-control"
              placeholder="Search Here"
              onInput={(text) => this.onSearch(text)}
            />
          </div>
          <p className="pt-3 text-center h3">Item List</p>
          <div className="pt-3 text-center">
            <div className="spinner-border" style={stylesASAP.spinner}></div>
          </div>
        </div>
      );
    }
  }
}
